import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import TextInput from "../../../components/form/TextInput";
import DropdownInput from "../../../components/form/DropdownInput";
import { useDropdowns } from "../../../hooks/useDropdowns";
import { UpdateProfileApi } from "../../../Services/profile";
import { useDispatch } from "react-redux";
import {
  SET_IS_API_CALLED,
  SET_IS_API_CALLED_FINISHED,
} from "../../../store/features/loadingSlice";
import { getProfileApi } from "../../../Services/user";

export default function UpdateProfile() {
  const { handleSubmit, control, formState, reset } = useForm();
  const dispatch = useDispatch();
  const { state, getRoleTypesDropDown } = useDropdowns();
  const { id } = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    getRoleTypesDropDown();

    getProfileApi(id).then((res) => {
      reset({
        email: res?.email,
        id: res?.id,
        roleId: res?.role?.id,
        userFullname: res?.userFullname,
        status: res?.status,
        status: res?.status,
        remarks: res?.remarks,
      });
    });
  }, []);

  const onSubmit = (data) => {
    dispatch(SET_IS_API_CALLED("Update Profile"));
    UpdateProfileApi({
      email: data?.email,
      roleId: data?.roleId,
      userFullname: data?.userFullname,
      remarks: data?.remarks,
      isActive: data.status === "Active" ? true : false,
    }).then((res) => {
      dispatch(SET_IS_API_CALLED_FINISHED());
    });
  };
  return (
    <div>
      <div className=" text-dark-blue-200 text-lg font-bold leading-normal mb-2 px-2">
        Profile
      </div>
      <div className=" w-[523px] px-2">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4 w-[346px]">
            <label
              htmlFor="title"
              className="block text-medium-blue text-lg font-normal leading-normal mb-1"
            >
              User Email
            </label>
            <Controller
              name="email"
              rules={{ required: "Email is required" }}
              control={control}
              render={({ field }) => (
                <TextInput
                  placeholder="Enter Email"
                  required
                  value={field.value}
                  validationMessages={{
                    required: `${formState?.errors?.email?.message || " "}`,
                  }}
                  onChange={field.onChange}
                />
              )}
            />
          </div>
          <div className="mb-4 w-[346px]">
            <label
              htmlFor="title"
              className="block text-medium-blue text-lg font-normal leading-normal mb-1"
            >
              User Full Name
            </label>
            <Controller
              name="userFullname"
              rules={{ required: "User Full Name is required" }}
              control={control}
              render={({ field }) => (
                <TextInput
                  placeholder="John Doe"
                  required
                  value={field.value}
                  validationMessages={{
                    required: `${
                      formState?.errors?.userFullname?.message || " "
                    }`,
                  }}
                  onChange={field.onChange}
                />
              )}
            />
          </div>
          <div className="mb-4 w-[346px]">
            <label
              htmlFor="title"
              className="block text-medium-blue text-lg font-normal leading-normal mb-1"
            >
              Role
            </label>
            <Controller
              name="roleId"
              rules={{ required: "Role is required" }}
              control={control}
              render={({ field }) => (
                <DropdownInput
                  required
                  validationMessages={`${
                    formState?.errors?.roleId?.message || " "
                  }`}
                  onChange={field.onChange}
                  items={state?.roleTypesDropDown}
                  value={"id"}
                  label={"name"}
                  selectedOption={field.value}
                />
              )}
            />
          </div>
          <div className="mb-4 w-[346px]">
            <label
              htmlFor="title"
              className="block text-medium-blue text-lg font-normal leading-normal mb-1"
            >
              Status
            </label>
            <Controller
              name="status"
              rules={{ required: "Status is required" }}
              control={control}
              render={({ field }) => (
                <DropdownInput
                  required
                  validationMessages={`${
                    formState?.errors?.status?.message || " "
                  }`}
                  onChange={field.onChange}
                  items={[
                    {
                      id: 1,
                      name: "Online",
                      value: "Active",
                    },
                    {
                      id: 2,
                      name: "Offline",
                      value: "Inactive",
                    },
                  ]}
                  value={"value"}
                  label={"name"}
                  selectedOption={field.value}
                />
              )}
            />
          </div>
          <div className="mb-4 w-full">
            <label
              htmlFor="content"
              className="block text-medium-blue text-lg font-normal leading-normal mb-1"
            >
              Remarks
            </label>

            <Controller
              name="remarks"
              rules={{ required: "Remarks are required" }}
              control={control}
              render={({ field }) => (
                <>
                  <textarea
                    id="content"
                    onChange={field.onChange}
                    value={field.value}
                    rows={4}
                    className="border border-light-grey-500 rounded-md p-2 w-full"
                  />
                  <p className="mt-2 text-red-500 text-xs">
                    {`${formState?.errors?.remarks?.message || " "}`}
                  </p>
                </>
              )}
            />
          </div>
          <div className="flex justify-end items-center gap-4">
            <Link to={"/setting/change-password"}>
              <div className=" text-dark-blue-200 hover:text-blue-600 text-lg font-bold leading-normal mb-2 px-2">
                Change Password
              </div>
            </Link>
            <button
              type="submit"
              className="bg-dark-blue-200 hover:bg-blue-600 text-white w-[193px] h-[52px] font-bold text-lg "
            >
              <div className=" flex justify-center items-center gap-5">
                <span>Update profile</span>
              </div>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
